import { FC } from 'react'
import { useTranslation } from 'react-i18next'
import ConnStateUnknown from '@assets/images/common/conn-state-unknown.ico'
import { FormInput } from '@microservices/wiskey-react-components'
import { Delete } from '@mui/icons-material'
import ExpandMoreIcon from '@mui/icons-material/ExpandMore'
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Box,
  Grid,
  IconButton,
  Typography,
} from '@mui/material'

import { useSection } from '@pages/WindowsCreateOrEdit/components/Section/hooks/useSection'
import { Tabs } from '@pages/WindowsCreateOrEdit/components/Tab'

import { PageContentLayout } from '@layouts/PageContentLayout'
import { CustomSvgIcon } from '@components/CustomSvgIcon'

import { GENERATOR_INPUT_TYPE } from '@constants'

type SectionProps = {
  index: number
  removeSection: (index: number, sectionId: number) => void
}

export const Section: FC<SectionProps> = ({ index, removeSection }) => {
  const { t } = useTranslation()
  const { data, state } = useSection(index)

  const { watchSectionTitle, watchSectionId } = data
  const { errors } = state

  return (
    <PageContentLayout sx={{ p: 1 }}>
      <Accordion>
        <AccordionSummary
          expandIcon={<ExpandMoreIcon />}
          sx={{
            my: 0,
            minHeight: '48px !important',
            '& .MuiAccordionSummary-content': {
              m: '0px !important',
            },
          }}
        >
          <Typography alignSelf={'center'} flexGrow={1}>
            {`${t('window.section.label')} ${index + 1} ${watchSectionTitle}`}
            {errors?.sections?.[index]?.title && (
              <CustomSvgIcon src={ConnStateUnknown} sx={{ width: 24, height: 26 }} />
            )}
          </Typography>
          <IconButton title='Remove section' onClick={() => removeSection(index, watchSectionId)}>
            <Delete />
          </IconButton>
        </AccordionSummary>
        <AccordionDetails>
          <Box sx={{ border: '1px solid', borderColor: 'divider', borderRadius: 1, p: 1 }}>
            <Grid display='flex' justifyContent={'space-between'} px={1}>
              <FormInput
                inputType={GENERATOR_INPUT_TYPE.INPUT}
                label={`${t('window.section.label')} ${index + 1}`}
                name={`sections.${index}.title`}
                placeholder={t('window.section.placeholder')}
                sx={{ width: '100%' }}
                rules={{
                  required: true,
                  validate: value => value.trim().length !== 0,
                }}
              />
            </Grid>
            <Tabs sectionIndex={index} />
          </Box>
        </AccordionDetails>
      </Accordion>
    </PageContentLayout>
  )
}
